module.exports = __webpack_public_path__ + "static/img/process-19.2079ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-19.png
// module id = 6aF6
// module chunks = 0